import { DateRangeField, DecoratedFormUnit, SelectField } from '@mi-front/ui';
import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { StationsSelect } from '../../../../../../components/stations/StationsSelect';
import { StationsTimezoneSelect } from '../../../../../../components/stations/StationsTimezoneSelect';
import { useTimezone } from '../../../../../../core/hooks';
import { useStationsWithAudit } from '../../../../hooks/useStationsWithAudit';
import { GlobalMissingAudiosReport } from '../types';
import { groupByOptionToLabelMessage } from './messages';
import { GroupByHelp } from './GroupByHelp';
import { groupByOptions } from './group-by-options';

export const GlobalMissingAudiosReportForm = () => {
  const stations = useStationsWithAudit();
  const { $t } = useIntl();
  const tz = useTimezone();
  const fp = useFormikContext<GlobalMissingAudiosReport['Values']>();

  return (
    <div>
      <div className="row">
        <div className="col-4">
          <DecoratedFormUnit
            label={$t({
              id: 'common.datetimeRange',
              defaultMessage: 'Rango de fecha y hora',
            })}
          >
            <DateRangeField name={['from', 'to']} tz={tz} />
          </DecoratedFormUnit>
        </div>
        <div className="col-3">
          <SelectField
            name="groupBy"
            label={
              <div>
                {$t({
                  id: 'common.groupBy',
                  defaultMessage: 'Agrupar por',
                })}{' '}
                <GroupByHelp
                  linkText={$t({
                    id: 'common.help',
                    defaultMessage: 'Ayuda',
                  })}
                />
              </div>
            }
            options={groupByOptions}
            getOptionValue={(m) => m.id}
            getOptionLabel={(m) => $t(groupByOptionToLabelMessage[m.id])}
          />
        </div>
        <div className="col-3">
          <StationsTimezoneSelect
            disabled={fp.isSubmitting}
            onChange={(value: string) => fp.setFieldValue('timezone', value)}
            value={fp.values.timezone}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-9">
          <StationsSelect stations={stations} multiple />
        </div>
      </div>
    </div>
  );
};
